export enum ContentBlockType {
    Editor = 1,
    ImageAndEditor = 2
}